export const soundTimeline = [
    {
        name: 'fireStart',
        startTime: 0,
        volume: 0.5,
    },
];
